import { UserRolesEnum } from "./user-roles.enum";

export class LoginModel {
    username: string;
    password: string;
    userId: number;
    companyId: number;
    role: UserRolesEnum;

    /**
     * 
     * @param username 
     * @param password 
     * @param userId 
     * @param companyId 
     * @param role
     */
    constructor(username: string, password: string, userId: number, companyId: number, role: UserRolesEnum) {
        this.username = username;
        this.password = password;
        this.userId = userId;
        this.companyId = companyId;
        this.role = role;
    }
}